import createSubmit from '../../Form/createSubmitButton.jsx'
import {name} from './AdditionalInfoStepForm.jsx'

export default createSubmit(name)